import ReactModal from 'react-modal/dist/react-modal'
import React from 'react'
import './modals.css'

export const Modal = ({ isOpen, toggle, className, title, children }) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={toggle}
    className={'Modal__Bootstrap modal-dialog ' + className}
    overlayClassName='modal-backdrop'
    ariaHideApp={false}
    style={{
      overlay: { overflow: 'scroll' }
    }}
  >
    <div className='modal-content'>
      <ModalHeader>
        <h4 className='modal-title'>{title}</h4>
        <button type='button' className='close' onClick={toggle}>
          <span aria-hidden='true'>×</span>
          <span className='sr-only'>Close</span>
        </button>
      </ModalHeader>
      {children}
    </div>
  </ReactModal>
)

export const ModalFooter = ({ children }) => (
  <div className='modal-footer'>
    {children}
  </div>
)

export const ModalHeader = ({ children }) => (
  <div className='modal-header'>
    {children}
  </div>
)

export const ModalBody = ({ children }) => (
  <div className='modal-body'>
    {children}
  </div>
)
